export const maxValueText = "n.d."